module.exports = __webpack_public_path__ + "static/media/io.aecf8a97.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/io.svg
// module id = 848
// module chunks = 0